import React from 'react';
import Navbar from '../components/Navbar';
import './TentangKami.css';
import { IoInformationCircleOutline, IoRocketOutline, IoPeopleOutline } from "react-icons/io5";
import timImage from '../5.jpg'; // Menggunakan foto tim sebagai aset utama

const TentangKami = () => {
  return (
    <div className="about-page">
      <Navbar />
      <main className="about-content">
        {/* Hero Section yang Diperluas */}
        <div className="team-hero-card" style={{ backgroundImage: `url(${timImage})` }}>
          <div className="team-hero-overlay">
            <div className="team-hero-text">
              <h1>Tim Kami</h1>
              <p>Perkenalkan kami perwakilan dari Telkom University dalam pembuatan sistem ini.</p>
            </div>
          </div>
        </div>

        {/* Grid 3 Kotak Informasi */}
        <div className="about-grid-three">
          <section className="info-card">
            <div className="info-header">
              <IoInformationCircleOutline className="info-icon" />
              <h2>Apa itu Agrid?</h2>
            </div>
            <p>
              Platform Internet of Things (IoT) untuk membantu pembudidaya mengawasi parameter vital air secara otomatis dan akurat.
            </p>
          </section>

          <section className="info-card">
            <div className="info-header">
              <IoRocketOutline className="info-icon" />
              <h2>Visi & Misi</h2>
            </div>
            <p>
              Mendorong digitalisasi sektor akuaponik guna meningkatkan efisiensi pakan dan kesehatan ekosistem air berkelanjutan.
            </p>
          </section>

          <section className="info-card">
            <div className="info-header">
              <IoPeopleOutline className="info-icon" />
              <h2>Kontribusi</h2>
            </div>
            <p>
              Berfokus pada integrasi teknologi informasi dan pertanian modern (Smart Farming) untuk pemberdayaan masyarakat.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default TentangKami;